import CryptoJS from "crypto-js";
export const passwordEncoder = (str) => {
  try {
    const secretKey = process.env.REACT_APP_SECRETE_KEY;
    const iv = process.env.REACT_APP_IV_KEY;
    const cipherText = CryptoJS.AES.encrypt(str, CryptoJS.enc.Hex.parse(secretKey), { iv: CryptoJS.enc.Hex.parse(iv), mode: CryptoJS.mode.CBC} ).toString();
    return cipherText;
  } catch (error) {
    console.log("error", error);
  }
};

export const passwordDecoder = (str) => {
  try {
    const secretKey = process.env.REACT_APP_SECRETE_KEY;
    const iv = process.env.REACT_APP_IV_KEY;
    const cipherText = CryptoJS.AES.decrypt(str, CryptoJS.enc.Hex.parse(secretKey), { iv: CryptoJS.enc.Hex.parse(iv), mode: CryptoJS.mode.CBC} ).toString(CryptoJS.enc.Utf8);
    return cipherText;
  } catch (error) {
    console.log("error", error);
  }
};
